import { useWorkOrderRecord } from "@/app/ProDrivers/WorkOrders/Hooks/useWorkOrderRecord";
import { WorkOrderFlow } from "@/app/ProDrivers/WorkOrders/Components/WorkOrderFlow";
import { WorkOrderDetailsCard } from "@/app/ProDrivers/WorkOrders/Components/Cards/WorkOrderDetailsCard";
import { WorkOrderQuoteCard } from "@/app/ProDrivers/WorkOrders/Components/Cards/WorkOrderQuoteCard";
import { WorkOrderDriverCard } from "@/app/ProDrivers/WorkOrders/Components/Cards/WorkOrderDriverCard";
import { WorkOrderEmptyDriverCard } from "@/app/ProDrivers/WorkOrders/Components/Cards/WorkOrderEmptyDriverCard";
import { WorkOrderInvoiceCard } from "@/app/ProDrivers/WorkOrders/Components/Cards/WorkOrderInvoiceCard";
import { useLocation } from "@tanstack/react-router";

export function WorkOrderDetailsScreen() {
  const workOrder = useWorkOrderRecord();
  const { hash } = useLocation();
  const assignments = workOrder.assignments ?? [];
  const driversRequired = workOrder.number_of_drivers ?? 1;

  // Create array of driver slots (assigned + empty)
  const driverSlots = Array.from({ length: driversRequired }, (_, index) => ({
    index,
    assignment: assignments[index] ?? null,
  }));

  const getCardClassName = (cardId: string) =>
    `scroll-mt-4 rounded-lg transition-shadow ${hash === cardId ? "ring-2 ring-blue-200" : ""}`;

  return (
    <div className="space-y-10 py-10">
      <WorkOrderFlow />

      <div className="space-y-6">
        <div id="card-request" className={getCardClassName("card-request")}>
          <WorkOrderDetailsCard workOrder={workOrder} />
        </div>
        <div id="card-quote" className={getCardClassName("card-quote")}>
          <WorkOrderQuoteCard />
        </div>
        {driverSlots.map(({ index, assignment }) => (
          <div
            key={assignment?.id ?? `empty-${index}`}
            id={`card-driver-${index}`}
            className={getCardClassName(`card-driver-${index}`)}
          >
            {assignment ? (
              <WorkOrderDriverCard
                assignment={assignment}
                workOrderId={workOrder.id}
                index={index}
              />
            ) : (
              <WorkOrderEmptyDriverCard
                workOrderId={workOrder.id}
                index={index}
              />
            )}
          </div>
        ))}
        <div id="card-invoice" className={getCardClassName("card-invoice")}>
          <WorkOrderInvoiceCard />
        </div>
      </div>
    </div>
  );
}
